import { VISIBLE_STATE } from "./StateConstants.ts"


export class Partnership {
  objectId
  createdAt
  updatedAt
  title
  location
  address
  phoneNumber
  websiteLink
  description
  listItems
  linkText
  linkURL
  logoImage
  heroImage
  hidden
  shortDescription
  hiddenState
  sortingPosition

  constructor(
    objectId = "",
    createdAt = null,
    updatedAt = null,
    title = "",
    location = "",
    address = "",
    phoneNumber = "+44",
    websiteLink = "",
    description = "",
    listItems = [],
    linkText = "",
    linkURL = "",
    logoImage = undefined,
    heroImage = undefined,
    hidden = undefined,
    shortDescription = undefined,
    hiddenState = undefined,
    sortingPosition = 99
  ) {
    this.objectId = objectId
    this.createdAt = createdAt
    this.updatedAt = updatedAt
    this.title = title
    this.location = location
    this.address = address
    this.phoneNumber = phoneNumber
    this.websiteLink = websiteLink
    this.description = description
    this.listItems = listItems
    this.linkText = linkText
    this.linkURL = linkURL
    this.logoImage = logoImage
    this.heroImage = heroImage
    this.hidden = hidden
    this.shortDescription = shortDescription
    this.hiddenState = hiddenState
    this.sortingPosition = sortingPosition
  }

  static normalizeSortingPosition(value) {
    const parsed = Number.parseInt(value, 10)
    if (Number.isNaN(parsed)) {
      return 99
    }
    return Math.min(100, Math.max(1, parsed))
  }

  convertLocationToMapObject() {
    return {
      lat: this.location.latitude,
      lng: this.location.longitude,
    }
  }

  static convertFromParseObject(parseObject) {
    const hiddenState = parseObject?.get("hidden") ? VISIBLE_STATE.PRIVATE : VISIBLE_STATE.PUBLIC

    return new Partnership(
      parseObject?.id,
      parseObject?.createdAt,
      parseObject?.updatedAt,
      parseObject?.get("title"),
      parseObject?.get("location"),
      parseObject?.get("address"),
      parseObject?.get("phoneNumber"),
      parseObject?.get("websiteLink"),
      parseObject?.get("description"),
      parseObject?.get("listItems"),
      parseObject?.get("linkText"),
      parseObject?.get("linkURL"),
      parseObject?.get("logoImage")?.url(),
      parseObject?.get("heroImage")?.url(),
      parseObject?.get("hidden"),
      parseObject?.get("shortDescription"),
      hiddenState,
      parseObject?.get("sortingPosition") ?? 99
    )
  }
}
